/** Download a run's PDF report (audited server-side). Disabled until the run
 *  has one. */

import { useState } from "react";
import { Button } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useAccessToken } from "@/features/auth/useAccessToken";
import { downloadRunReport, type RunOut } from "@/shared/api/solutionRuns";
import { toastApiError } from "@/shared/ui/toast";

interface Props {
  run: Pick<RunOut, "run_id" | "name" | "has_report">;
  label?: string;
}

function fileName(name: string): string {
  const safe = name.replace(/[^\w\- ().]+/g, "_").trim() || "report";
  return `${safe}.pdf`;
}

export function ReportDownloadButton({ run, label = "Download report (PDF)" }: Props) {
  const getToken = useAccessToken();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      await downloadRunReport(await getToken(), run.run_id, fileName(run.name));
    } catch (err) {
      toastApiError("Could not download the report", err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="light"
      leftSection={<IconDownload size={16} />}
      onClick={() => void download()}
      disabled={!run.has_report}
      loading={busy}
    >
      {label}
    </Button>
  );
}
